import { ProposalOrderReduced } from '@/models/proposal-order-reduced.model';
import { LoadingService } from '@/services/loading.service';
import { Util } from '@/utils/util';
import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-dialogExclusive',
  templateUrl: './dialogExclusive.component.html',
  styleUrls: ['./dialogExclusive.component.scss'],
})
export class DialogExclusiveComponent {

  proposalOrderReduced!: ProposalOrderReduced;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProposalOrderReduced,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogExclusiveComponent>,
    private loadingService: LoadingService,
    private utilService: Util
  ) {
    this.proposalOrderReduced = data;
  }

  formatDate(isoDate: string): string {
    return this.utilService.formatDate(isoDate);
  }

  formatCurrency(currency: number) {
    return this.utilService.convertCurrencyToBRL(currency);
  }

  onRightButton() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
